import $api from './instance';
import type { IPayment, IUnitTypeWithPayments } from '@/types';

export async function getRentPaymentsRequest(): Promise<IPayment[]> {
  const res = await $api.get('/statistics/rent-payments');
  return res.data;
}

export async function getUnitTypesWithPaymentsRequest(): Promise<
  IUnitTypeWithPayments[]
> {
  const res = await $api.get('/statistics/unit-types');
  return res.data;
}


export interface IDashboardStatistics {
  success: boolean;
  data: {
    overview: {
      paidRents: {
        amount: number;
        pendingCount: number;
        currency: string;
      };
      arrears: {
        amount: number;
        overdueCount: number;
        currency: string;
      };
      tasks: {
        total: number;
        inProgress: number;
      };
      tenants: {
        total: number;
        registeredOnPlatform: number;
      };
    };
    buildings: {
      [key: string]: {
        type: string;
        totalUnits: number;
        statistics: {
          paid: { count: number; percentage: number };
          arrears: { count: number; percentage: number };
          notSet: { count: number; percentage: number };
          pending: { count: number; percentage: number };
        };
      };
    };
  };
}

export async function getDashboardStatisticsRequest(): Promise<IDashboardStatistics> {
  const res = await $api.get('/statistics/dashboard');
  return res.data;
}

export async function getPropertyUnitsStatistics(propertyId: number) {
  const res = await $api.get(`/statistics/properties/${propertyId}/units`);
  return res.data;
}

export async function getPropertyPaymentsStatistics(
  propertyId: number,
  period?: string,
) {
  const res = await $api.get(`/statistics/properties/${propertyId}/payments`, {
    params: { period },
  });
  return res.data;
}

// Нові інтерфейси для статистики Property
export interface IPropertyStatisticsData {
  units: {
    // total: number; // Removed as per new API response
    leased: number;
    pending: number;
    vacant: number;
  };
  payments: { // Renamed from paymentsPercentage
    paid: number;
    arrears: number;
    notSet: number;
  };
}

export interface IPropertyStatisticsResponse {
  success: boolean;
  data: IPropertyStatisticsData;
}

/**
 * Отримати статистику для Property
 */
export async function getPropertyStatisticsRequest(propertyId: number): Promise<IPropertyStatisticsResponse> {
  const response = await $api.get<IPropertyStatisticsResponse>(`/statistics/property/${propertyId}`);
  return response.data;
}
